import { Injectable } from '@angular/core';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { Store } from '@ngrx/store';
import { AppState } from '../types';
import { exportActions } from './export.actions';
import { exportSelectors } from './export.selector';
import { SearchRequest } from '../search/types';
import { FileModel } from './types';

@Injectable()
export class ExportService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  exportToCsv: GenericApiCall<FileModel, SearchRequest> = this.genericApiCall(
    exportActions.exportToCsv,
    exportSelectors.exportToCsv,
    true,
  );
}
